import { createRouter, createWebHashHistory } from "vue-router";
import { auth } from "./store";

const router = createRouter({
    history: createWebHashHistory(), // createWebHistory for html5 state
    routes: [
        {
            path: "/login",
            name: "login",
            props: (route) => ({ next: route.query.next }),
            component: require("./views/auth/SignIn.vue").default,
            meta: {
                title: "Sign In"
            }
        },
        {
            path: "/sign-up",
            name: "sign-up",
            props: (route) => ({ next: route.query.next }),
            component: require("./views/auth/SignUp.vue").default,
            meta: {
                title: "Sign Up"
            }
        },
        {
            path: "/code",
            name: "code",
            props: (route) => ({ next: route.query.next, email: route.query.email }),
            component: require("./views/auth/SignInCode.vue").default,
            meta: {
                title: "Code"
            }
        },
        {
            path: "/logout",
            name: "logout",
            component: require("./views/auth/Logout.vue").default,
            meta: {
                title: "Logout"
            }
        },

        {
            path: "/",
            name: "home",
            component: require("./views/Home.vue").default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/create",
            name: "create",
            component: require("./views/Create.vue").default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/profile",
            name: "profile",
            props: (route) => ({ id: route.query.id }),
            component: require("./views/Profile.vue").default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/credits",
            name: "credits",
            props: (route) => ({ id: route.query.id }),
            component: require("./views/Credits.vue").default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/upload",
            name: "upload",
            props: (route) => ({ id: route.query.id }),
            component: require("./views/Upload.vue").default,
            meta: {
                requiresAuth: true
            }
        },

        /* other */
        {
            path: "/:catchAll(.*)",
            name: "not-found",
            component: require("./views/NotFound.vue").default,
            meta: {
                title: "Not Found"
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // run check once
        if (!auth.state.status.loggedIn) { // no auth
            next({
                name: "login",
                query: { next: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        // kill session on pages that do not require auth specifically
        if (to.matched[0].meta && to.matched[0].meta.requiresAuth === false) {
            // remove session from these pages
        }

        next();
    }
});

export default router;
